import type { FC } from 'react';
import { useAppTranslation } from '@flowus/common/i18n';

export const OthersPreview: FC = () => {
  const { t } = useAppTranslation();
  return (
    <div className="w-full h-full pointer-events-none flex flex-col items-center justify-center">
      <p className="text-[70px] leading-[80px] text-center">👀</p>
      <p className="text-white">{t('file_preview_components.other.format_not_supported')}</p>
    </div>
  );
};
